import { serviceRoute } from './service';

export const allServiceRoutes = [serviceRoute()];
